/**
 * RESPONSIBILITY: the paths the FRAMEWORK serves. Not the app's.
 *
 * Named `FRAMEWORK_` because the framework owns these and only these. A site adds its
 * own — a contact form, a newsletter sign-up — in `app/`, and hands them to `createApp`,
 * which mounts them before the SPA catch-all. Anything registered after `createApp()`
 * returns is shadowed by that catch-all and never reached.
 */
export const FRAMEWORK_ROUTES = {
  sectionQuery: '/api/sections/query',
  sectionWrite: '/api/sections',
  flushAll: '/api/sections/flush-all',
  section: (name: string, lang: string) => `/api/sections/${name}?lang=${lang}`,
  sectionHistory: (name: string, lang: string) => `/api/sections/${name}/history?lang=${lang}`,
  upload: (folder: string) => `/api/upload/${folder}`,
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  me: '/api/auth/me',
  profile: '/api/auth/profile',
  changePassword: '/api/auth/change-password',
  register: '/api/auth/register',
  captcha: '/api/auth/captcha',
  adminUsers: '/api/admin/users',
  adminDecide: (id: string) => `/api/admin/users/${id}/decide`,
  adminRoles: (id: string) => `/api/admin/users/${id}/roles`,
  clientErrors: '/api/client-errors',
  /** Editor-only. Renders markdown with the SAME code that renders it on save. */
  markdownPreview: '/api/markdown/preview',
} as const;
